import Entity from '../entity'
export default class MotivoDevolucion extends Entity<number>{
    
    motivoDevolucion: string;
    descripcion: number;
    cambio: boolean;
    
}
